import {
  TransferFondoPensioneWizard,
  TransferFondoPensioneWizardStepEnum,
} from 'app/src/features/Shopping/Transfer/TransferFondoPensione/components/TransferFondoPensioneWizard'
import { moneytransferApi, shoppingApi, TransferStatusValueEnum } from 'app/src/services/welfareportal'
import { PageWidget } from 'app/src/shared/components'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export function TransferFondoPensione() {
  const params = useParams()

  const credit = shoppingApi.useCreditGet(
    {},
    {
      meta: {
        skip404Errors: true,
      },
    },
  )
  const transferGet = moneytransferApi.useTransferRequestGet({
    pathParams: {
      transferId: params['id']!,
    },
  })

  const { t } = useTranslation('shopping', { keyPrefix: 'Transfer' })

  /** spinner when fetching data */
  if (transferGet.isLoading || credit.isLoading || transferGet.isFetching || credit.isFetching) {
    return (
      <PageWidget>
        <h1 className='welfareportal-titlecenter'>{t('loadingInProgressTitle')}</h1>
        <div className='mt-20 flex'>
          <div className='mx-auto'>
            <ProgressSpinner data-testid='loading-element' className='flex' />
            {t('loadingInProgressDescription') && (
              <div className='mt-4' dangerouslySetInnerHTML={{ __html: t('loadingInProgressDescription') }} />
            )}
          </div>
        </div>
      </PageWidget>
    )
  }

  if (credit.isError || transferGet.isError) {
    return (
      <TransferFondoPensioneWizard
        transferDetails={transferGet?.data}
        creditDetails={credit?.data}
        initialStep={TransferFondoPensioneWizardStepEnum.ERROR_GENERIC}
      />
    )
  } else if (!transferGet?.isError && transferGet?.data && !credit.isError && credit.data) {
    switch (transferGet?.data?.status?.value) {
      case TransferStatusValueEnum.DRAFT.toString():
        return (
          <TransferFondoPensioneWizard
            transferDetails={transferGet?.data}
            creditDetails={credit?.data}
            initialStep={TransferFondoPensioneWizardStepEnum.FIRST_STEP}
          />
        )
        break
      case TransferStatusValueEnum.SUBMITTED.toString():
      case TransferStatusValueEnum.CANCELED.toString():
      case TransferStatusValueEnum.CONFIRMED.toString():
      case TransferStatusValueEnum.REJECTED.toString():
        return (
          <TransferFondoPensioneWizard
            transferDetails={transferGet?.data}
            creditDetails={credit?.data}
            initialStep={TransferFondoPensioneWizardStepEnum.DETAIL_STEP}
          />
        )
        break
      case TransferStatusValueEnum.FAILED.toString():
        return (
          <TransferFondoPensioneWizard
            transferDetails={transferGet?.data}
            creditDetails={credit?.data}
            initialStep={TransferFondoPensioneWizardStepEnum.ERROR_GENERIC}
          />
        )
        break
      default:
        break
    }
  } else return
}
